import gsap from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import MoreProductsScene from '../3D/MoreProductsScene';

class ScrollItem__BlockProductThumbnails extends ScrollItem__BlockDefault {
    _items = [];
    _revealed = false;

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        // this._gridIndex = MoreProductsScene.getGridIndex(this.item);

        const header = GetBy.class('block-more-products__header', this.item)[0];
        if (header) gsap.set(header, { opacity: 0, y: 20 });

        const itemEls = GetBy.class('block-more-products__item', this.item);
        for (let i = 0; i < itemEls.length; i++) {
            gsap.set(itemEls[i], { opacity: 0, y: 40 });
            this._items.push({ el: itemEls[i], index: i });
        }

        this.onShow = () => {
            if (this._revealed) return;
            this._revealed = true;

            super.showCb();

            MoreProductsScene.showTempGrid();

            if (header) {
                gsap.to(header, {
                    opacity: 1, y: 0, duration: 1, delay: 0.3, ease: 'power3.out',
                    onComplete: () => gsap.set(header, { clearProps: 'opacity,y' }),
                });
            }

            this._items.forEach(({ el, index }) => {
                gsap.to(el, {
                    opacity: 1, y: 0,
                    duration: 1,
                    delay: 0.5 + index * 0.12,
                    ease: 'power3.out',
                    onComplete: () => gsap.set(el, { clearProps: 'opacity,y' }),
                });
            });
        };

        this.onHide = () => { };

        this.onMove = () => {
            MoreProductsScene.moveTempGrid(this.progress);
        };
    }
}

Scroll._registerClass('BlockProductThumbnails', ScrollItem__BlockProductThumbnails);

export default ScrollItem__BlockProductThumbnails;
